/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Invalid_RoundInputs */



/**
* | output |
* | --- |
* | "Invalid round number" |
*
* @param {Err_Tournament_Invalid_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_invalid_round = /** @type {((inputs?: Err_Tournament_Invalid_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Invalid_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Numéro de ronde invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de ronda no válido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Número de rodada inválido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di round non valido")
	return /** @type {LocalizedString} */ ("Invalid round number")
});